export const VALIDATION_PATTERN = {
	FULL_NAME: /^[a-zA-Z][a-zA-Z'\-., ]+$/,
	PHONE: /(^\d{10}$)|(^(\d{3}-){2}\d{4}$)/
};

export default VALIDATION_PATTERN;
